export default __webpack_public_path__ + "static/media/NCSA-Ad_1-3.71a5f302.png";